import React, { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/SidebarComponent/Sidebar/Sidebar";
import Footer from "../components/footer/Footer";
import AuthNav from "../components/nav/AuthNav";
import { isUserLoggedIn } from "../services/auth/AuthAPI";
import { stat } from "fs";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import ConfirmLogoutModal from "../components/Template/ConfirmLogoutModal";
import { RootState } from "../redux/Store";
import { useAppDispatch } from "../redux/useAppDispatch";
import { closeLogoutModal, openLogoutModal } from "../redux/EngageTranslation/EngageTranslationAction";

function AuthLayout(props: any) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [onEditPage, setOnEditPage] = useState(false);
  const [onViewDocPage, setOnViewDocPage] = useState(false);
  const location = useLocation();
  const logoutOpenState = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.logoutConfirmOpenState);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    const checkUserLogin = async () => {
      // setLoading(true);
      const status = await isUserLoggedIn();

      setIsAuthenticated(status);
      setLoading(false);
    };
    checkUserLogin();
  }, []);

  useEffect(() => {
    const url = location.pathname.split("/");
    if (url.length === 3 && url[1] === "documents" && /\d/.test(url[2])) {
      setOnEditPage(true);
    } else {
      setOnEditPage(false);
    }

    setOnViewDocPage(url[3] === "view-document");
  }, [location.pathname]);

  if (loading) {
    return (
      <div
        className="app"
        style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? (
    <div className="app">
      <ConfirmLogoutModal
        openState={logoutOpenState}
        open={() => dispatch(openLogoutModal())}
        close={() => dispatch(closeLogoutModal())}
      />

      <AuthNav onEditPage={onEditPage} />
      <Sidebar />
      <Outlet />
      <Footer
        onEditPage={onEditPage}
        onViewDocPage={onViewDocPage}
      />
    </div>
  ) : (
    // <Redirect/>
    <Navigate to={"/"} />
  );

  // return (
  //   <div className="app">
  //     <AuthNav />
  //     <Sidebar />
  //     <Outlet />
  //     <Footer />
  //   </div>
  // );
}

export default AuthLayout;
